export default function singleFieldRow(length) {
  return length === 1;
}
